/**
 * 正则工具包
 * doc：http://npm.iklicen.com/-/web/detail/@klicen/regexp
 *
 * 正则列表
 * 正则校验类型        使用方法                    返回值
 * 手机号校验          phone('xxx')                {res: true/false, message: '手机号格式不正确'}
 * 电子邮件校验        email('xxx')                {res: true/false, message: '电子邮件格式不正确'}
 * 用户名校验          username('xxx')             {res: true/false, message：'用户名必须是6~16位的大小写字母和数字'}
 * 密码校验            password('xxx')             {res: true/false, message: '密码长度6~20位且至少包含1个大写字母、1个小写字母和1个数字'}
 * 身份证校验          idNumber('xxx')             {res: true/false, message: '身份证号码格式不正确'}
 * 车架号校验          vin('xxx')                  {res: true/false, message: '车架号格式不正确'}
 * 金额校验(6位小数)   moneyWithSixDecimal(xxx)    {res: true/false, message: '金额格式不正确，小数点后最多六位'}
 * 金额校验(2位小数)   moneyWithTwoDecimal(xxx)    {res: true/false, message: '金额格式不正确，小数点后最多两位'}
 * URL校验             url('xxx')                  {res: true/false, message: 'URL格式不正确'}
 * engineNumber       engineNumber('xxx')          {res: true/false, message: '发动机号格式不正确'}
 * plateNumber        plateNumber('xxx')           {res: true/false, message: '发动机号格式不正确'}
 *
 * Example Usage
 * import { regexpUtils, } from '@/utils';
 */

/* eslint-disable */
export const phone = value => ({
    res: /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(value),
    message: '手机号码格式不正确'
});

export const email = value => ({
    res: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value),
    message: '电子邮件格式不正确'
});

export const username = value => ({
    res: /^[a-zA-Z0-9]{6,16}$/.test(value),
    message: '用户名必须是6~16位的大小写字母和数字'
});

export const password = value => ({
    res: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/.test(value),
    message: '密码长度6~20位且至少包含1个大写字母、1个小写字母和1个数字'
});

export const idNumber = (value) => {
    const message = '身份证号码格式不正确';
    const w = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // weights
    const code = '10X98765432';
    let check_sum = 0;
    if (value.length != 18) {
        return { res: false, message };
    }
    for (let i = 0; i < 17; i++) {
        const c = value.charCodeAt(i);
        if (c >= 48 && c <= 57) { // 0-9
            check_sum += ((c - 48) * w[i]);
        } else {
            return { res: false, message };
        }
    }
    check_sum %= 11;
    return { res: value[17] == code[check_sum], message };
};

// 车架号强校验(同宙斯)
export const vin = value => {
    function vin_validator(vin) {
        const v = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 1, 2, 3, 4, 5, 6, 7, 8, 0, 1, 2, 3, 4, 5, 0, 7, 0, 9, 2, 3, 4, 5, 6, 7, 8, 9]; // values
        const w = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2]; // weights
        const code = '0123456789X';
        let check_sum = 0;
        if (vin.length != 17) {
            return false;
        }
        for (let i = 0; i < 17; i++) {
            const c = vin.charCodeAt(i);
            let n = 0;
            if (c >= 65 && c <= 90) { // A-Z, no I,O,Q
                n = c - 65 + 10;
            } else if (c >= 48 && c <= 57) { // 0-9
                n = c - 48;
            } else {
                return false;
            }
            check_sum += (w[i] * v[n]);
        }
        check_sum %= 11;
        return vin[8] == code[check_sum];
    }

    const a = vin_validator(value);
    const regexp = /^[0-9A-HJ-NPR-Z]{17}$/;
    const message = '车架号格式不正确';
    return { res: (regexp.test(value)) && a, message };
};

/**
 * 凯励程CRM自定义车架号校验
 * 车架号校验规则：固定的17位，由英文+数字混合而成，第一个字符为英文字符，校验时校验是否17位和第一个字符是否英文
 * http://axure.product.com/%E6%AC%A3%E6%82%A6%E9%80%94/%E6%96%B0%E4%BA%A7%E5%93%81%E6%A1%86%E6%9E%B6PRD_%E7%AC%AC%E4%BA%8C%E9%98%B6%E6%AE%B5%EF%BC%88%E5%B0%8F%E7%A8%8B%E5%BA%8F%EF%BC%89/#g=1&p=%E7%BB%91%E5%AE%9A%E6%88%91%E7%9A%84%E8%BD%A6
 */
// export const vin = value => {
//     const regexp = /^[a-zA-Z](?![a-zA-Z]+$)[0-9A-Za-z]{16}$/;
//     const message = '车架号格式不正确';
//     return { res: regexp.test(value), message };
// };

export const moneyWithSixDecimal = value => ({
    res: /^([1-9]\d*|0)((\.\d{1,6})?)$/.test(value - 0),
    message: '金额格式不正确，小数点后最多六位'
});

export const moneyWithTwoDecimal = value => ({
    res: /^([1-9]\d*|0)((\.\d{1,2})?)$/.test(value - 0),
    message: '金额格式不正确，小数点后最多两位'
});

export const url = value => {
    const regexp = new RegExp('(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]');
    const res = regexp.test(value);
    return {
        res,
        message: 'URL格式不正确'
    }
};

export const engineNumber = value => ({
    res: /^[0-9A-Z]{0,28}$/.test(value),
    message: '发动机号格式不正确',
});

export const mileage = value => ({
    res: /^\+?[1-9]\d{0,5}$/.test(value),
    message: '请输入正确的里程',
});

export const distance = value => ({
    res: /^\+?[1-9]\d{0,2}$/.test(value),
    message: '请输入1000km以内的距离',
});

export const connectorName = value => ({
    res: /^([\u4E00-\u9FA5]|[A-Za-z])+$/.test(value),
    message: '请输入中文或英文字母，最长20个字符',
});

export const mobileAndLinePhone = value => ({
    res: /\d{11}/.test(value),
    message: '请输入正确的电话/手机号',
});

// 校验固定电话(标准版)
export const linePhoneNumber = value => ({
    res: /^[0][1-9]{2,3}-[0-9]{7,8}$/.test(value),
    message: '请填写正确的格式',
});

// 校验固定电话(简易版只能数字或“-”)
export const linePhoneNumberEasy = value => ({
    res: /^([0-9-]+)$/.test(value),
    message: '请填写正确的格式',
});

// 校验车牌号码
export const plateNumber = value => ({
    res: /^$|^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/.test(value),
    message: '请输入正确的车牌号码',
});
// 大于0的正数
export const regNumber = value => ({
    res: /^([1-9]\d*)(\.\d{1,6})?$|^0\.\d{1,6}?$/.test(value),
    message: '请输入大于0的正数',
});
// 大于0的正数
export const integerNumber = value => ({
    res: /^([1-9]\d*)$/.test(value),
    message: '请输入大于0的整数',
});
